"use client";

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import { Content } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { ChevronLeft, ChevronRight } from "lucide-react";

type NotificationSliderProps = {
  notifications: Content.SiteSettingsDocumentDataNotificationsItem[];
  locale: Locales;
  className?: string;
  itemClassName?: string;
  contentWidth?: string;
};

const NotificationSlider = ({
  notifications,
  locale,
  className,
  itemClassName = "text-center",
  contentWidth = "clamp(300px, 80vw, 960px)",
}: NotificationSliderProps) => {
  if (notifications.length === 0) return null;

  const hasMultiple = notifications.length > 1;

  return (
    <Carousel
      opts={{ loop: true }}
      className={cn("flex w-full items-center justify-center gap-2 sm:gap-4", className)}
    >
      {hasMultiple && (
        <CarouselPrevious
          className="bg-transparent p-1 text-black hover:bg-black/5"
          aria-label={__("Previous notification", locale)}
        >
          <ChevronLeft size={18} />
        </CarouselPrevious>
      )}
      <div className="min-w-0" style={{ width: contentWidth }}>
        <CarouselContent>
          {notifications.map((notification, index) => (
            <CarouselItem
              key={index}
              className={cn("prose prose-sm sm:prose-base max-w-none leading-snug font-medium", itemClassName)}
            >
              <PrismicRichText field={notification.content} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </div>
      {hasMultiple && (
        <CarouselNext
          className="bg-transparent p-1 text-black hover:bg-black/5"
          aria-label={__("Next notification", locale)}
        >
          <ChevronRight size={18} />
        </CarouselNext>
      )}
    </Carousel>
  );
};

export default NotificationSlider;
